export default __webpack_public_path__ + "static/media/hammer.14d91b8c.svg";